module.exports = __webpack_public_path__ + "static/media/Default_Project_Image.fb0d5f0b.png";